import { APP_ACCESS_TOKEN_KEY, FIREBASE_ACCESS_TOKEN_KEY } from '@/config/auth';
import localStorageInstance from './LocalStorage';
import StorageInterface from './types';

interface TokkenStoreInterface {
  provider: StorageInterface;
  setFirebaseAccessToken: (token: string) => void;
  getFirebaseAccessToken: () => string | null;
  setAppAccessToken: (token: string) => void;
  getAppAccessToken: () => string | null;
  clearTokens: () => void;
}

export default class TokenStore implements TokkenStoreInterface {
  provider: StorageInterface;

  constructor() {
    this.provider = localStorageInstance;
  }

  setFirebaseAccessToken(token: string) {
    this.provider.set(FIREBASE_ACCESS_TOKEN_KEY, token);
    return token;
  }

  getFirebaseAccessToken() {
    return this.provider.get(FIREBASE_ACCESS_TOKEN_KEY);
  }

  setAppAccessToken(token: string) {
    this.provider.set(APP_ACCESS_TOKEN_KEY, token);
    return token;
  }

  getAppAccessToken() {
    return this.provider.get(APP_ACCESS_TOKEN_KEY);
  }

  clearTokens() {
    this.provider.remove(APP_ACCESS_TOKEN_KEY);
    this.provider.remove(FIREBASE_ACCESS_TOKEN_KEY);
  }
}

const tokenStore = new TokenStore();

export { tokenStore };
